import React from "react";
import { Link } from "react-router-dom";
import { Section, Eyebrow } from "../components/ui";
import { workGroups } from "../data/projects";

const Work = () => (
  <main>
    <Section>
      <Eyebrow>Work</Eyebrow>
      <h1 className="max-w-2xl text-5xl font-black leading-[1.02] tracking-tight text-ink sm:text-6xl">
        Selected projects, from AI-native ventures to national-scale public services.
      </h1>
      <div className="mt-12 grid gap-5 sm:grid-cols-3">
        {workGroups.map((g) => (
          <Link
            key={g.id}
            to={`/work/${g.id}`}
            className="group block overflow-hidden rounded-lg border border-line bg-paper transition-colors hover:border-accent"
          >
            <img
              src={g.image}
              alt=""
              loading="lazy"
              className="h-40 w-full object-cover object-top"
            />
            <div className="p-5">
              <span className="font-mono text-xs font-medium uppercase tracking-[0.14em] text-ink-faint">
                {g.items.length} project{g.items.length === 1 ? "" : "s"}
              </span>
              <h2 className="mt-2 text-lg font-bold text-ink group-hover:text-accent">
                {g.label}
              </h2>
            </div>
          </Link>
        ))}
      </div>
    </Section>
  </main>
);

export default Work;
